export default {
    surveyCollaborator:undefined,
    guideId:null,
    surveyId:null,
    loading: false,
    error: null,
    errorShow: false
}